import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="socialMedia">
          <ul>
            <li>
              <Link
                to="https://instagram.com/lvisgurugram"
                target="_blank"
                rel="noreferrer"
              >
                <i class="bi bi-instagram"></i>
              </Link>
            </li>
            <li>
              <Link
                to="https://www.facebook.com/lotusvalleyinternationalschoolgurugram/"
                target="_blank"
                rel="noreferrer"
              >
                <i class="bi bi-facebook"></i>
              </Link>
            </li>
            <li>
              <Link
                to="https://x.com/lvisgurugram"
                target="_blank"
                rel="noreferrer"
              >
                <i class="bi bi-twitter-x"></i>
              </Link>
            </li>
            <li>
              <Link
                to="https://www.linkedin.com/company/lotus-valley-international-school-gurgaon/posts/?feedView=all"
                target="_blank"
                rel="noreferrer"
              >
                <i class="bi bi-linkedin"></i>
              </Link>
            </li>
            <li>
              <Link
                to="https://www.youtube.com/channel/UCEqeTzMBvLsrM_dNDApKPrg/videos?view_as=subscriber"
                target="_blank"
                rel="noreferrer"
              >
                <i class="bi bi-youtube"></i>
              </Link>
            </li>
          </ul>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-md-4 col-sm-6 text-center">
              <div className="footer_blk">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/ftr-logo.png"
                    className="img-fluid ftr_logo"
                    alt="Lotus Valley school Gurgaon"
                  />
                </LazyLoad>
                <p className="font-small">Affiliation no - 531034</p>
                <p className="font-small">School Code - 40991</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-3 col-sm-6 contact">
              <div className="ftr-list">
                <h4 className="mt-4">Quick Links</h4>
                <ul className="list-ftr">
                  <li>
                    <Link to="/awardsAcheivements">Awards</Link>
                  </li>
                  <li>
                    <Link to="/magazine">E-Magazine</Link>
                  </li>
                  <li>
                    <Link to="/careers-openings">Career</Link>
                  </li>
                  <li>
                    <Link to="/admission">Admission</Link>
                  </li>
                  <li>
                    <Link to="/contactUs">Feedback</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-5 col-md-5 col-sm-12">
              <div className="contact">
                <h4 className="mt-4">Contact Us</h4>
                <p>
                  Lotus Valley International School, M-Block, South City-II,{" "}
                  <br />
                  Nirvana Country, Sector-50 (Behind North Close), Gurgaon -
                  122018
                </p>
                <p>
                  Phone : +91 9650544997 or 0124 - 4936900 <br />
                  e-mail :{" "}
                  <Link to="mailto:director@lotusvalleygugaon.com">
                    director@lotusvalleygugaon.com
                  </Link>
                  <br />
                  <Link to="mailto:info@lotusvalleygurgaon.com">
                    info@lotusvalleygurgaon.com
                  </Link>
                  <br />
                  e-mail :{" "}
                  <Link to="mailto:principal@lotusvalleygurgaon.com">
                    principal@lotusvalleygurgaon.com
                  </Link>
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            © Copyright 2018 - 2025 By Lotus Valley Gurgaon | Accelerating By{" "}
            <Link
              className="link"
              to="https://www.entab.in/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Entab Infotech : CampusCare®{" "}
            </Link>{" "}
          </p>
        </div>
      </div>
    </>
  );
};
export default Footer;
